<template>
  <div id="page">
    <div id='card_p' class="row topCardGrid">
      <sp-card :valor="servidoresAtivos.total_funcionarios" icon="fa fa-id-card-o boldness cor1" :descricao="$t('eixos.institucional.topCards.ativosTitulo')" classDesc="pull-right"
        stripe='none' :footerText="$t('eixos.institucional.topCards.ativosRodape', {data_consulta : dataFormatada , valor : servidoresAtivos.remuneracao_bruta.toLocaleString('pt-BR') })"/>

      <sp-card :valor="servidoresInativos.total_funcionarios" icon="glyphicon glyphicon-user" :descricao="$t('eixos.institucional.topCards.inativosTitulo')" classDesc="pull-right" stripe='none'
         :footerText="$t('eixos.institucional.topCards.inativosRodape', {data_consulta : dataFormatada , valor : servidoresInativos.remuneracao_bruta.toLocaleString('pt-BR')})" />

      <sp-card :valor="'R$'+ totalFolha" prefix="R$" icon="fa fa-money boldness cor1" :descricao="$t('eixos.institucional.topCards.gastosTitulo')" classDesc="pull-right"
        stripe='none' :footerText="$t('eixos.institucional.topCards.gastosRodape', {data_consulta : dataFormatada })" />

      <sp-card :valor="mediaIdade" sufix="anos" icon="glyphicon glyphicon-calendar" :descricao="$t('eixos.institucional.topCards.idadeMediaTitulo')" classDesc="pull-right"
        stripe='none' :footerText="$t('eixos.institucional.topCards.idadeMediaRodape', {data_consulta : dataFormatada})"/>

    </div>

    <div id="grafico_distribuicao_orgao" class="row">
       <div class="flex col md6 sm12">
        <sp-360-panel fit :image="matarazzo" :title="$t('eixos.institucional.lists.lista1.title')" :footerText="$t('eixos.institucional.lists.lista1.rodape', {data_consulta : dataFormatada })">
          <sp360-chart :data="servidoresPorCargo" type="horizontal-bar" :options="servidoresPorCargoOptions"/>
          <va-button v-show="true" outline color="danger" class="pull-right" @click="openModal1($event)">
            {{$t('eixos.institucional.lists.buttonList1')}}
          </va-button>
          <br/><br/>
        </sp-360-panel>
      </div>
      <div class="flex col md6 sm12">
        <sp-360-panel fit :image="tesouro" :title="$t('eixos.institucional.lists.lista2.title')" :footerText="$t('eixos.institucional.lists.lista1.rodape', {data_consulta : dataFormatada })">
          <sp360-chart :data="servidoresPorOrgao" type="horizontal-bar" :options="servidoresPorOrgaoOptions"/>
          <va-button v-show="true" outline color="danger" class="pull-right" @click="openModal2($event)">
            {{$t('eixos.institucional.lists.buttonList2')}}
          </va-button>
          <br/><br/>
        </sp-360-panel>
      </div>
    </div>

    <!-- <div id="listas" class="row">
      <div class="flex lg6 md6 sm12">
        <sp360-list fit :title="$t('eixos.institucional.lists.titleList1')">
          <template v-for="(m, index) in lista1" class="list">
            <va-item>
              <va-item-section>
                <va-item-label>
                  Label
                </va-item-label>
                <va-item-label caption>
                  Caption
                </va-item-label>
              </va-item-section>
            </va-item>
            <va-list-separator v-if="index < lista1.lenght-1" />
          </template>
          <va-button v-show="true" outline color="danger" class="pull-right">
            {{$t('eixos.institucional.lists.buttonList1')}}
          </va-button>
        </sp360-list>
      </div>
      <div class="flex lg6 md6 sm12">
        <sp360-list fit :title="$t('eixos.institucional.lists.titleList2')">
          <template v-for="(m, index) in lista2" class="list">
            <va-item>
              <va-item-section>
                <va-item-label>
                  Label
                </va-item-label>
                <va-item-label caption>
                  Caption
                </va-item-label>
              </va-item-section>
            </va-item>
            <va-list-separator v-if="index < lista2.lenght-1" />
          </template>
          <va-button v-show="true" outline color="danger" class="pull-right">
            {{$t('eixos.institucional.lists.buttonList2')}}
          </va-button>
        </sp360-list>
      </div>
    </div>

    <div id="bottom" class="row">
      <div class="flex md4 lg4 sm12 inside">
        <sp-360-panel title="Titulo1"></sp-360-panel>
      </div>
      <div class="flex md4 lg4 sm12 inside">
        <sp-360-panel title="Titulo1"></sp-360-panel>
      </div>
      <div class="flex md4 lg4 sm12 inside">
        <sp-360-panel title="Titulo1"></sp-360-panel>
      </div>
    </div> -->

    <div id="modals">
      <va-modal show.sync="true" ref="modalLista1" :okText="$t('modal.close')" :okClass="'btn btn-primary btn-sm'"
        size="large" v-model="showModalLista1" :title="$t('eixos.institucional.modal1.title')" :cancelText="''"  class="modals">
        <template slot="default">
          <!-- <va-tabs center grow v-model="tabValue">
            <va-tab :key="0" v-on:tabClick="click()">
              Grafico
            </va-tab>
            <va-tab :key="1" v-on:tabClick="click()">
              Tabela
            </va-tab>
          </va-tabs>
          <div class="row" v-show="tabClick">
            <sp360-chart :data="servidoresPorCargoTotal" type="horizontal-bar" :options="servidoresPorCargoOptions" />
          </div> -->

          <div class="row">
            <sp360-data-table id="tabelaCargos" ref="tabelaCargos" :data="filtrarLista1"
              :fields="camposTabelaLista1" :perPage="itemsPerPage" :onEachSide="onEachSide"
              :dataModeFilterableFields="dataModeFilterableFieldsTabelaLista1" :sortFunctions="sortFunctionsTabelaLista1"/>
          </div>
        </template>
      </va-modal>
      <va-modal ref="modalLista2" :okText="$t('modal.close')" :okClass="'btn btn-primary btn-sm'" :cancelText="''"
        size="large" v-model="showModalLista2" :title="$t('eixos.institucional.modal2.title')" class="modals">
        <template slot="default">
          <!-- <va-tabs center grow v-model="tabValue">
            <va-tab :key='0' v-on:tabClick="click()">
              Grafico
            </va-tab>
            <va-tab :key="1" v-on:tabClick="click()">
              Tabela
            </va-tab>
          </va-tabs>
          <sp360-chart :data="servidoresPorOrgaoTotal" type="horizontal-bar" :options="servidoresPorOrgaoOptions" v-show="tabClick" class="modalChart"/> -->
          <sp360-data-table id="tabelaOrgaos" ref="tabelaOrgaos" :data="filtrarLista2"
            :fields="camposTabelaLista2" :perPage="itemsPerPage" :onEachSide="onEachSide"
            :dataModeFilterableFields="dataModeFilterableFieldsTabelaLista2" :sortFunctions="sortFunctionsTabelaLista2" />
        </template>
      </va-modal>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import MethGlob from '@/utils/MetodosGlobais'
import Constantes from '@/utils/ConstantesGlobais'
import Donut from '@/components/statistics/charts/GraficoDonut.vue'
import CorUtils from '@/utils/CorUtils'

import SpCard from '@/components/ui/cards/SP360Card'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import SPMapaNomes from '@/utils/SPMapaNomes'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360List from '@/components/ui/list/VaList'
import matarazzo from '@/assets/images/edMat.jpg'
import tesouro from '@/assets/images/tesouro.jpg'

export default {
  name: 'eixo-urbano',
  components: {
    Donut,
    SpCard,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
    Sp360List,
    Constantes,
  },
  data () {
    return {
      matarazzo: matarazzo,
      tesouro: tesouro,

      servidoresPorOrgao: {},
      servidoresPorOrgaoTotal: {},
      servidoresPorOrgaoOptions: {},

      servidoresPorCargo: {},
      servidoresPorCargoTotal: {},
      servidoresPorCargoOptions: {},

      dataConsulta: new Date(),
      servidoresInativos: { remuneracao_bruta: 0 },
      servidoresAtivos: { remuneracao_bruta: 0 },
      totalFolha: 0,
      mediaIdade: 0,

      showModalLista1: false,
      showModalLista2: false,
      // tabClick: true,
      // tabValue: 0,

      tabelaLista1: [1, 2, 3, 4, 5],
      tabelaLista2: [1, 2, 3, 4, 5],
      lista1: [1, 2, 3, 4, 5],
      lista2: [1, 2, 3, 4, 5],

      onEachSide: 1,
      itemsPerPage: 8,

      camposTabelaLista1: [{
        name: 'cargo',
        sortField: 'cargo',
        title: this.$t('eixos.institucional.lists.lista1.tableFields.cargo'),
        width: '60%',
      }, {
        name: 'soma_vencimento_cargo',
        sortField: 'soma_vencimento_cargo',
        title: this.$t('eixos.institucional.lists.lista1.tableFields.soma_vencimento_cargo'),
        callback: function (value) {
          return 'R$' + MethGlob.formatarGrandesNumeros(value)
        },
        width: '13%',
      }, {
        name: 'media_vencimento_cargo',
        sortField: 'media_vencimento_cargo',
        title: this.$t('eixos.institucional.lists.lista1.tableFields.media_vencimento_cargo'),
        callback: function (value) { return 'R$' + MethGlob.formatarGrandesNumeros(value) },
        width: '13%',
      }, {
        name: 'total_pessoas',
        sortField: 'total_pessoas',
        title: this.$t('eixos.institucional.lists.lista1.tableFields.total_pessoas'),
        callback: function (value) { return MethGlob.formatarGrandesNumeros(value) },
        width: '13%',
      }],

      camposTabelaLista2: [{
        name: 'nome_secretaria',
        sortField: 'nome_secretaria',
        title: this.$t('eixos.institucional.lists.lista2.tableFields.nome_secretaria'),
        width: '50%',
        callback: function (value) { return MethGlob.abreviarOrgaos(value) },
      }, {
        name: 'folha_pagamento_bruta',
        sortField: 'folha_pagamento_bruta',
        title: this.$t('eixos.institucional.lists.lista2.tableFields.folha_pagamento_bruta'),
        callback: function (value) { return 'R$' + MethGlob.formatarGrandesNumeros(value) },
        width: '20%',
      },
      {
        name: 'per_capita',
        sortField: 'per_capita',
        title: this.$t('eixos.institucional.lists.lista2.tableFields.per_capita'),
        callback: function (value) { return 'R$' + MethGlob.formatarGrandesNumeros(value) },
        width: '20%',
      }, {
        name: 'total_pessoas',
        sortField: 'total_pessoas',
        title: this.$t('eixos.institucional.lists.lista2.tableFields.total_pessoas'),
        callback: function (value) { return MethGlob.formatarGrandesNumeros(value) },
        width: '10%',
      }],

      dataModeFilterableFieldsTabelaLista1: ['cargo'],
      sortFunctionsTabelaLista1: {
        'cargo': MethGlob.ordenaTabela,
        'total_pessoas': MethGlob.ordenaTabelaParseInt,
        'soma_vencimento_cargo': MethGlob.ordenaTabelaParseFloat,
        'media_vencimento_cargo': MethGlob.ordenaTabelaParseFloat,
      },
      dataModeFilterableFieldsTabelaLista2: ['nome_secretaria', 'folha_pagamento_bruta'],
      sortFunctionsTabelaLista2: {
        'nome_secretaria': MethGlob.ordenaTabela,
        'per_capita': MethGlob.ordenaTabelaParseInt,
        'total_pessoas': MethGlob.ordenaTabelaParseInt,
        'folha_pagamento_bruta': MethGlob.ordenaTabelaParseFloat,
      },
    }
  },
  created () {
    Promise.all([
      this.$store.dispatch('funcionalismo/buscarConsolidadoPorTipoRegime', {}),
      this.$store.dispatch('funcionalismo/buscarConsolidadoPorEscolaridade', {}),
      this.$store.dispatch('funcionalismo/buscarConsolidadoPorOrgao', {}),
      this.$store.dispatch('funcionalismo/buscarConsolidadoPorCargo', {}),
    ]).then(respostas => {
      // {fonte: fonte, data: dataRef}
      // :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"
      this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
      this.dataRef = new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
      this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })

      this.calcularCards(respostas[0].data.data)
      this.lista1 = _.orderBy(respostas[3].data.data, ['total_pessoas'], ['desc'])
      this.servidoresPorCargoOptions = this.getchartOptions('Número Servidores', 'Cargo')
      this.servidoresPorCargo = this.montarGraficoPorCargo(this.lista1.slice(0, 10))
      this.servidoresPorCargoTotal = this.montarGraficoPorCargo(this.lista1)

      this.lista2 = _.orderBy(respostas[2].data.data, ['folha_pagamento_bruta'], ['desc'])
      this.servidoresPorOrgaoOptions = this.getchartOptions('Total Folha (R$)', 'Orgão')
      this.servidoresPorOrgao = this.montarGraficoPorOrgao(this.lista2.slice(0, 10), this.servidoresPorOrgaoOptions)
      this.servidoresPorOrgaoTotal = this.montarGraficoPorOrgao(this.lista2, this.servidoresPorOrgaoOptions)
    })
  },
  mounted () {},

  computed: {

    dataFormatada () {
      const o = { year: 'numeric', month: 'short' }
      return this.dataConsulta.toLocaleDateString('pt-BR', o)
    },

    filtrarLista1 () {
      return this.lista1
    },

    filtrarLista2 () { return this.lista2 },
  },

  methods: {

    click () {
      this.tabClick = !this.tabClick
    },

    openModal1 () { return this.showModalLista1 = !this.showModalLista1 },

    openModal2 () { return this.showModalLista2 = !this.showModalLista2 },

    calcularCards (dados) {
      if (dados) {
        this.dataConsulta = new Date(dados[0].data_folha_pagamento)
        this.servidoresAbonoPermanencia = dados[0]
        this.servidoresInativos = dados[1]
        this.servidoresAtivos = dados[2]
        let folha = 0
        dados.forEach(e => {
          folha += Number.parseFloat(e.remuneracao_bruta)
        })
        this.totalFolha = MethGlob.formatarGrandesNumeros(folha)
        this.mediaIdade = this.servidoresAtivos.media_idade
      }
    },

    montarGraficoPorCargo (dados) {
      let chartData = { datasets: [], labels: [] }

      let dataset = {
        backgroundColor: CorUtils.getCorPorNomeSp360('amarelo-medio'),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => value.toLocaleString('pt-BR'),
          anchor: 'start',
          align: 'end',
          display: 'true',
          font: {
            weight: 'bold',
          },
        },
      }

      dados.forEach(element => {
        if (element) {
          chartData.labels.push(MethGlob.abreviarCargos(element.cargo))
          dataset.data.push(element.total_pessoas)
          dataset.label = 'Servidores Por Cargo'
        }
      })

      chartData.datasets.push(dataset)

      return chartData
    },

    montarGraficoPorOrgao (dados, options) {
      let chartData = { datasets: [], labels: [] }

      let dataset = {
        backgroundColor: CorUtils.getCorPorNomeSp360('amarelo-bistre-claro'),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => 'R$' + MethGlob.formatarGrandesNumeros(value),
          anchor: 'start',
          align: 'end',
          display: 'true',
          labels: {
            value: {
              font: {
                weight: 'bold',
              },
            },
          },
        },
      }

      dados.forEach(element => {
        if (element) {
          chartData.labels.push(MethGlob.abreviarOrgaos(element.nome_secretaria))
          dataset.data.push(element.folha_pagamento_bruta)
          dataset.label = 'Folha por Orgão'
        }
      })

      chartData.datasets.push(dataset)

      // Options
      options.scales.xAxes[0].ticks.callback = function (value, index, values) { return 'R$' + MethGlob.formatarGrandesNumeros(value) }
      options.scales.xAxes[0].ticks.beginAtZero = false
      options.scales.xAxes[0].ticks.maxTicksLimit = 11
      options.scales.xAxes[0].type = 'logarithmic'

      return chartData
    },

    getchartOptions (xAxixLabel, yAxixLabel) {
      return {
        layout: {
          padding: {
            left: 0,
            right: 5,
            top: 50,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {
          },
        },
        tooltips: {
          enabled: true,
          intersect: true,
          callbacks: {
            title: function (tooltipItems, data) {
              var title = ''
              var labels = data.labels
              var labelCount = labels ? labels.length : 0

              if (tooltipItems.length > 0) {
                var item = tooltipItems[0]
                if (item.label) {
                  title = item.label
                } else if (item.xLabel) {
                  title = item.xLabel
                } else if (labelCount > 0 && item.index < labelCount) {
                  title = labels[item.index]
                }
              }

              return title
            },
            label: function (tooltipItem, details) {
              if (details.datasets[tooltipItem.datasetIndex].label == 'Folha por Orgão') {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label + ': ' + 'R$' + MethGlob.formatarGrandesNumeros(currentValue)
              } else {
                let dataset = details.datasets[tooltipItem.datasetIndex]
                let currentValue = dataset.data[tooltipItem.index]
                return dataset.label + ': ' + currentValue.toLocaleString('pt-BR')
              }
            },
          },
        },
        responsive: true,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            categoryPercentage: 0.2,
            barPercentage: 1.0,
            scaleLabel: {
              display: true,
              labelString: yAxixLabel,
            },
            ticks: {
              beginAtZero: true,
              autoSkip: false,
              callback: function (value, index, values) {
                return MethGlob.formatarGrandesNumeros(value)
              },
            },
          }],
          xAxes: [
            {
              id: 'BarAxis',
              position: 'left',
              gridLines: {
                display: false,
              },
              scaleLabel: {
                display: true,
                labelString: xAxixLabel,
              },
              ticks: {
                callback: function (value, index, values) {
                  return value.toLocaleString('pt-BR')
                },
              },
            },
          ] },
      }
    },

    montarTabelas (dados) {

    },

  },
}
</script>

<style lang="scss" scoped>
  .img-card {
    .va-card__image{
        padding-bottom: 20% !important;
    }
  }

  .list {
    padding: 0.02rem
  }

  .boldness{
      font-size: 2.5vw;
      font-weight: 900;
      @include media-breakpoint-down(sm) {
        font-size: 7.5vw;
      }
  }

  .enfase{
      font-size: 1rem;
      font-weight: 900;
  }

  .va-chart{
    max-height:30rem ;
  }

  .modals{
    ._inner{
      max-width:100%;
    }
      .va-chart{
        max-height:50rem ;
        max-width:50rem;
      }
  }

</style>
